<template>
  <div class="content">
    <div class="title">影票订单</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="-1"></el-tab-pane>
      <el-tab-pane label="待出票" name="3"></el-tab-pane>
      <el-tab-pane label="已出票" name="4"></el-tab-pane>
      <el-tab-pane label="已结算" name="5"></el-tab-pane>
      <el-tab-pane label="已关闭" name="10"></el-tab-pane>
    </el-tabs>
    <Search :searchForm="searchForm" :searchList="searchList" :optionsType="optionsType" :promoteList="promoteList"
    :optionsTypeCoupon="optionsTypeCoupon"
    >
    </Search>
    <!--    表格-->
    <el-table class="table" v-loading="searchForm.Loading" :data="tableList.list" border highlight-current-row
      style="width: 100%;" header-row-class-name="header">
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column
        v-for="(item, index) in tableData"
        v-bind="{...item}"
        :key="index"
        :prop="item.value"
        :label="item.text"
        align="center"
      >
        <template slot-scope="{row}">
          <span v-if="item.value === 'orderId'" class="click" @click="detail(row)">
            {{ row[item.value] }}
          </span>
          <el-tag
            v-if="item.value === 'orderId'"
            v-clipboard:copy="row[item.value]"
            v-clipboard:success="onCopy"
            style="cursor: pointer;"
            size="mini"
          >复制</el-tag>
          <div v-else-if="item.value === 'payAmount'">
            <div>{{ row.payAmount }}</div>
            <div class="color-red" v-if="row.couponPrice">(优惠券{{ row.couponPrice }})</div>
          </div>
          <div v-else-if="item.value === 'appCommission'">
            <el-tooltip placement="right">
              <div slot="content">套餐分润比例：{{ row.packageCommissionRate }}%
                <template v-if="![null, 0].includes(row.floatCommission)">
                  <br />浮动溢价结算：{{ row.floatCommission > 0 ? '+' : '-' }}{{ row.floatCommission }}
                </template>
                <template v-if="row.couponPrice"><br />优惠券结算：{{ row.couponCommission }}</template>
                <template v-if="row.dyDarenSellPremium && row.couponPrice == 0"><br />达人溢价结算：{{ row.dyDarenSellPremium }}</template>
              </div>
              <span class="color-blue color-blue__underline">{{ row.appCommission }}</span>
            </el-tooltip>
          </div>
          <span v-else-if="item.value === 'num'">{{ ((row.orderPrice / row.initPrice) * 100).toFixed(2) }}%</span>
          <span v-else-if="item.value === 'commissionRate'">{{ row.commissionRate }}%</span>
          <span v-else>{{ row[item.value] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="影票信息" align="center" fixed="right">
        <template slot-scope="{row}">
          <span class="look" @click="detail(row)">查看</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="120">
        <template slot-scope="{row}">
          <!-- 待出票，非秒出单，未发起拦截或者取消拦截，才能发起拦截 -->
          <div class="span"
            v-if="row.orderStatus <= 3 && row.orderType != 3 && (row.interceptOrderStatus === null || row.interceptOrderStatus == 5)"
            @click="intercept(row)">拦截订单</div>
          <div class="span"
            v-if="row.orderStatus == 3 && row.orderType != 3 && [0, 3, 4].includes(row.interceptOrderStatus)"
            @click="cancelIntercept(row)">取消拦截</div>
          <!-- 待出票，非秒出单，近10分钟未催票过，才能发起催票 -->
          <div class="span" v-if="row.orderStatus == 3 && row.orderType != 3 && !row.remindLog" @click="pushOut(row)">
            催出票
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination v-if="tableList.total > 0" class="pagination" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]"
      :page-size="tableList.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="tableList.total">
    </el-pagination>
    <!--   影票详情-->
    <detail v-if="detailShow" :detailShow="detailShow" :detailInfo="detailInfo"></detail>
    <!--  拦截-->
    <el-dialog :title="isPushOut ? '催出票' : '拦截订单'" :visible.sync="dialogVisible" width="30%"
      :before-close="handleClose">
      <div class="dialog" style="text-align: center">
        <div v-if="isPushOut">
          <div class="dialog-text">确认催出票？</div>
          <div class="dialog-text">每个订单10分钟内只能发起一次催出票</div>
        </div>
        <div style="display: flex" v-else>
          <div class="dialog-text" style="width: 100%;">确定发起拦截？发起拦截后。不保证拦截成功</div>
          <!--        <textarea class="textarea" v-model="remark"></textarea>-->
        </div>
        <div>
          <span class="color-red">请稍后刷新页面查看结果</span>
        </div>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogVisible = false">取消</div>
          <div class="button-success" @click="confirm()">确定</div>
        </div>
      </div>
    </el-dialog>
    <!--    拦截成功提示-->
    <el-dialog title="提示" :visible.sync="hintShow" width="40%" :before-close="handleClose">
      <div class="dialog-content">
        <div>
          <div class="dialog-text">已发起拦截。不保证拦截成功</div>
        </div>
        <div>
          <span class="color-red">请稍后刷新页面查看结果</span>
        </div>
        <div class="dialogFooter" style="margin-left: auto;margin-right: 40px;margin-top: 50px">
          <div class="dialogFooter-ok" @click="hintShow = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="取消拦截" :visible.sync="dialogVisibleCancel" width="40%" :before-close="handleClose">
      <div class="dialog">
        <div>
          <div class="dialog-text">确认取消拦截？</div>
        </div>
        <div class="dialog-button">
          <div class="button-cancel" @click="dialogVisibleCancel = false">取消</div>
          <div class="button-success" @click="cancelOrder()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
const MiniModel = new mini()
import detail from "./components/detail";

export default {
  name: "index",
  components: {
    Search,
    detail
  },
  data() {
    return {
      activeName: '-1',
      searchForm: {
        promoteCode: '', // 推广位名称
        reservedPhone: '',// 手机号
        appKey: localStorage.getItem('appKeyMini'),
        // interceptStatus: '',
        nickName: '',
        orderCreateEndTime: '',
        orderCreateStartTime: '',
        orderId: '',
        orderStatus: '',
        pageSize: 10,
        pageNo: 1,
        total: '',
        Loading: true,
        time: [],
        orderType: 1,
        isCouponOrde: "",
        couponTypeId:'',// 是否优惠券下单
      },
      dialogVisible: false,
      searchList: [
        {
          id: 'orderId',
          text: '订单号',
          placeholder: '请输入订单号',
          type: 'input',

        }, {
          id: 'id',
          text: '用户ID',
          placeholder: '请输入用户ID',
          type: 'input'
        }, {
          id: 'reservedPhone',
          text: '手机号',
          placeholder: '请输入手机号',
          type: 'input',
          maxlength: 11,
        }, {
          id: 'interceptOrderStatus',
          text: '拦截状态',
          placeholder: '请选择拦截状态',
          type: 'select'
        },
        {
          id: 'promoteCode',
          text: '推广位名称',
          placeholder: '请选择推广位名称',
          type: 'select'
        },
        {
          id: 'time',
          text: '下单日期',
          type: 'timeOrder',
          isHide: true
        },
        {
          id: 'couponTypeId',
          text: '是否优惠券下单',
          type: 'select',
          // optionsType: [
          //   {
          //     label: '全部',
          //     value: ""
          //   },
          //   {
          //     label: '是',
          //     value: "1"
          //   }, {
          //     label: '否',
          //     value: "0"
          //   }
          // ],
        },
        {
          id: 'selectType',
          text: '订单类型',
          type: 'selectType'
        },
      ],
      // 表头
      tableData: [{
        text: '订单ID',
        value: 'orderId',
      },
      {
        text: '用户ID',
        value: 'fansId',
      }
        , {
        text: '手机号',
        value: 'reservedPhone',
      }
        , {
        text: '市场价（元）',
        value: 'initPrice',
      }
        , {
        text: '支付金额（元）',
        value: 'payAmount',
      }
        , {
          text: '优惠券金额（元）',
          value: 'cheaperPriceBd',
        }
        , {
          text: '优惠券类型',
          value: 'couponType',
        }
        , {
          text: '优惠券承担人',
          value: 'couponHolder',
        },
      {
        text: '订单总佣金（元）',
        value: 'commission',
      }, {
        text: '我的佣金（元）',
        value: 'appCommission',
      }, {
        text: '佣金比例',
        value: 'commissionRate',
      }, {
        text: '订单状态',
        value: 'orderStatusStr',
      },
      // {
      //   text: '订单类型',
      //   value: 'orderTypeStr',
      // },
      {
        text: '拦截状态',
        value: 'interceptOrderStatusStr',
      }, {
        text: '接受调座',
        value: 'acceptChangeSeatStr',
      }, {
        text: '出票时间',
        value: 'ticketDurationStr',
      }, {
        text: '创建时间',
        value: 'orderCreateTimeStr',
      },
      {
        text: '影片名称',
        value: 'movieName',
      }
      ],
      tableList: [],
      currentPage: 1,
      detailShow: false,
      detailInfo: {}, // 详情
      remark: '用户取消',
      item: {},
      isPushOut: false,
      optionsType: [
        {
          label: '未拦截',
          value: 0
        }, {
          label: '拦截中',
          value: 1
        }, {
          label: '拦截成功',
          value: 2
        }, {
          label: '拦截失败',
          value: 3
        }
      ],
      promoteList: [ // 推广位列表
      ],
      dialogVisibleCancel: false,
      hintShow: false,
      optionsTypeCoupon: [
        {
          label: '全部',
          value: ""
        },
        {
          label: '是',
          value: "1"
        }, {
          label: '否',
          value: "0"
        }
      ],
    }
  },
  created() {

  },
  mounted() {
    if (this.$route.query.name) {
      this.searchForm.nickName = this.$route.query.name
    }
    this.$parent.activeIndex = 2
    // 默认时间选择框下单时间为7天
    this.searchForm.time = [
      new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
      new Date(),
    ];
    // timeList日期格式转换为年月日
    const timeList = this.searchForm.time.map((item) => {
      return this.formatDateHandel(item);
    });
    this.searchForm.orderCreateStartTime = timeList[0] + ' 00:00:00';
    this.searchForm.orderCreateEndTime = timeList[1] + ' 23:59:59';
    this.getList()
    this.getPromoteList();
  },
  methods: {
    //复制
    onCopy: function (e) {
      this.$Message.success('复制成功');
    },
    // 获取推广位名称列表
    async getPromoteList() {
      const data = await MiniModel.getPromoteList({
        appKey: localStorage.getItem('appKeyMini')
      })
      if (data.data.code === 200) {
        this.promoteList = data.data.data.map((item) => (
          {
            value: item.code,
            label: item.name
          }
        ))
      }
    },
    getList(str) {
      if (str === 'reset') {
        this.searchForm.time = []
      }
      this.searchForm.Loading = true
      MiniModel.getOrderList(this.searchForm).then(res => {
        if (res.data.code == 200) {
          this.tableList.list = res.data.data.list.map((item)=>{
            return {
              ...item,
              cheaperPriceBd: item.cheaperPriceBd ? item.cheaperPriceBd : "-",
              couponType: item.couponType ? item.couponType : "-",
              couponHolder: item.couponHolder ? item.couponHolder : "-",
            };
          })
          this.tableList.total = res.data.data.total;
          this.tableList.pageSize = res.data.data.pageSize
          this.searchForm.Loading = false
        } else {
          this.$message.error(res.data.info)
          this.searchForm.Loading = false
        }
      })
    },
    handleClick(e) {
      console.log(e)
      if (e.name == -1) {
        this.searchForm.orderStatus = ''
      } else {
        this.searchForm.orderStatus = e.name
      }
      this.searchForm.reservedPhone = ''
      this.searchForm.interceptOrderStatus = ''
      this.searchForm.orderType = 1
      this.searchForm.orderId = ''
      this.searchForm.id=''
      this.searchForm.promoteCode = ''
      this.searchForm.time = [
        new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
        new Date(),
      ]
      // timeList日期格式转换为年月日
      const timeList = this.searchForm.time.map((item) => {
        return this.formatDateHandel(item);
      });
      this.searchForm.orderCreateStartTime = timeList[0] + ' 00:00:00';
      this.searchForm.orderCreateEndTime = timeList[1] + ' 23:59:59';

      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisibleCancel = false
      this.hintShow = false
    },
    // 序号
    indexMethod(index) {
      index = (index + 1) + (this.searchForm.pageNo - 1) * this.searchForm.pageSize
      return index
    },
    detail(item) {
      console.log('item', item)
      let param = {
        orderId: item.orderId
      }
      MiniModel.getOrderDetail(param).then(res => {
        if (res.data.code == 200) {
          this.detailInfo = res.data.data
          this.detailShow = true
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    intercept(row) {
      this.dialogVisible = true
      this.isPushOut = false
      this.item = row
    },
    // 取消拦截
    cancelIntercept(row) {
      this.dialogVisibleCancel = true
      this.item = row
    },
    cancelOrder() {
      let params = {
        appKey: localStorage.getItem('appKeyMini'),
        orderUUID: this.item.orderUUID
      }
      MiniModel.cancelIntercept(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('发起成功')
          this.dialogVisibleCancel = false
        } else {
          this.$message.error(res.data.info || res.data.message || res.data.data.message)
        }
        this.getList()
      })
    },
    confirm() {
      console.log('this.isPushOut', this.isPushOut)
      if (this.isPushOut) {
        let params = {
          appKey: localStorage.getItem('appKeyMini'),
          orderUUID: this.item.orderUUID,
          urgeSource: 2
        }
        MiniModel.pushOut(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('发起成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.info || res.data.message || res.data.data.message)
          }
        })
      } else {
        if (this.remark == '') {
          this.$message.error('请输入备注')
          return
        }
        let params = {
          interceptReason: this.remark,
          orderUUID: this.item.orderUUID,
          sourceType: 3
        }
        MiniModel.orderIntercept(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('拦截发起成功')
            // this.hintShow = true
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.info || res.data.message || res.data.data.message)
          }
        })
      }
    },
    pushOut(row) {
      this.dialogVisible = true
      this.isPushOut = true
      this.item = row
    },
    // 导出
    exportButton() {
      this.exportLoading = true;
      MiniModel.exportMovieOrder({...this.searchForm,entrance:10}).then(async res => {
        const code = res.data.code
        const message = res.data.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
      }).finally(()=>{
        this.exportLoading = false
      })
    },
    formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      console.log(y + m + d)
      return y + m + d;
    },
    formatDateHandel(date) {
      var year = date.getYear() + 1900; // getYear返回的是从1900年开始算起的年份，需加上1900
      var month = date.getMonth() + 1; // getMonth返回的是0-11，需要加1
      var day = date.getDate();

      // 格式化为yyyy-mm-dd格式
      var formattedDate = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
      return formattedDate;
    }
  }
}
</script>

<style scoped lang="less">
.content {
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }
}

.table {
  margin-top: 30px;
}

.detail {
  display: flex;
  align-items: center;

  .detail-item {
    display: flex;
    margin-top: 20px;

    .item-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }

    .item-span {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 20px;
    }
  }
}

.dialog {

  //padding: 20px 80px;
  .dialog-title {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }

  .dialog-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
  }

  .textarea {
    border: 1px solid #e5e5e5;
    height: 100px;
    margin-left: 10px;
    width: 300px;
  }

  .dialog-button {
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;

    .button-success {
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .button-cancel {
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.look {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #3D9EFC;
  line-height: 18px;
  cursor: pointer;
}

.span {
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF9734;
  line-height: 32px;
  cursor: pointer;
  min-width: 76px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #FF8622;
  text-align: center;
  cursor: pointer;
  margin: auto;
  margin-bottom: 15px;
}

.click {
  cursor: pointer;
}

.dialogFooter-ok {
  width: 100px;
  font-size: 13px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF9734;
  line-height: 32px;
  min-width: 76px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #FF8622;
  text-align: center;
  cursor: pointer;
  margin: auto;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #EEEEEE;
}

/deep/.el-tabs__item.is-active {
  color: #FF8622 !important;
}

/deep/.el-tabs__active-bar {
  background-color: #FF8622 !important;
}

/deep/.el-tabs__item:hover {
  color: #FF8622 !important;
}

/deep/.el-table th,
.el-table tr {
  background-color: #FCFAF8;
}

/deep/.el-date-editor .el-range-separator {
  line-height: 25px !important;
}

/deep/.el-tabs__nav-wrap::after {
  height: 1px !important;
}

/deep/.el-date-editor .el-range__icon {
  line-height: 25px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/order/index.vue